import { useWindowSize } from 'usehooks-ts';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import Address from '../Address';
import LoginButton from '../login/LoginButton';
import { useTheme } from '../theme/Theme';
import ThemeLogo from '../theme/ThemeLogo';
import ToolTip from '../toolTip/Tooltip';
import './UserDropdown.scss';

const Menu = () => {
  const [{ user }] = useGlobalState();
  const { userLogout } = useLoginHelper();
  const [theme, toggleTheme] = useTheme();
  const isDark = theme === 'dark';

  const copyAddress = () => {
    alert.info('Address copied', { autoClose: 200 });
    window.navigator.clipboard.writeText(user.address);
  };

  return (
    <>
      <a className='usermenu_button' href='https://docs.google.com/forms/d/e/1FAIpQLSe7rI9SGuvZOrVkNhK4skKBuev2HJvXtaRr0mEUNOrwjnrkxg/viewform' target='_blank'>
        <ThemeLogo icon={'request'} /> Request project
      </a>
      <a className='usermenu_button' href='https://discord.gg/0xmercle' target='_blank'>
        <ThemeLogo icon={'support'} /> Get support
      </a>
      <button className='usermenu_button' onClick={userLogout}>
        <ThemeLogo icon={'logout'} /> Logout
      </button>
      <button className='dark_button' onClick={toggleTheme}>
        <ThemeLogo icon={'themeLogo'} /> {isDark ? 'Light Theme' : 'Dark Theme'}
      </button>
    </>
  );
};

const UserDropdown = () => {
  const [{ user }] = useGlobalState();
  const { width } = useWindowSize();

  if (!user) return <LoginButton />;
  return (
    <ToolTip className='UserDropdown-container navbar_login_button' tipContent={<Menu />} showOnClick={true}>
      <img src={user?.avatarUrl} alt='user_image' />
      {width <= 600 ? <></> : <Address a={user?.address} redirect={false} />}
      <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
        <path d='M9.99997 12.25L5.49997 7.75H14.5L9.99997 12.25Z' fill='#525866' />
      </svg>
    </ToolTip>
  );
};

export default UserDropdown;
